import React from 'react';
import './style.scss';
import FAQS from '../../dummyData/FAQS.json';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Calendar from '../../assets/images/icon/calendar.png';
import { APPLICATION_OPEN_DATE, APPLICATION_CLOSE_DATE, APPLICATION_OPEN_DATE_DISPLAY, APPLICATION_CLOSE_DATE_DISPLAY } from '../../constants';
import LeafletEn from '../../dummyData/2026_Sitare_Admissions_Leaflet.pdf';
import LeafletHi from '../../dummyData/2026_Sitare_Admissions_Leaflet.pdf';
// import SecondaryBanner from '../../components/sections/SecondaryBanner';
const Admissions = () => {
  const [activeKey, setActiveKey] = useState(null);
  const toggleItem = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const today = new Date();
  const applicationOpenDate = APPLICATION_OPEN_DATE;
  const applicationCloseDate = APPLICATION_CLOSE_DATE;

  const renderInline = (text, keyPrefix) =>
    text.split(/(\*\*[^*]+\*\*)/g).map((chunk, i) =>
      chunk.startsWith('**') && chunk.endsWith('**')
        ? <strong key={`${keyPrefix}-${i}`}>{chunk.slice(2, -2)}</strong>
        : <React.Fragment key={`${keyPrefix}-${i}`}>{chunk}</React.Fragment>
    );

  const renderAnswer = (text) => {
    const blocks = [];
    let buffer = [];
    let bullets = [];
    const flushBuffer = () => {
      if (buffer.length) {
        blocks.push({ type: 'p', lines: buffer });
        buffer = [];
      }
    };
    const flushBullets = () => {
      if (bullets.length) {
        blocks.push({ type: 'ul', items: bullets });
        bullets = [];
      }
    };
    text.split('\n').forEach((line) => {
      const trimmed = line.trimStart();
      if (trimmed.startsWith('• ')) {
        flushBuffer();
        bullets.push(trimmed.slice(2));
      } else {
        flushBullets();
        buffer.push(line);
      }
    });
    flushBuffer();
    flushBullets();

    return blocks.map((block, idx) => {
      if (block.type === 'ul') {
        return (
          <ul key={idx} className="faq-bullets">
            {block.items.map((item, i) => (
              <li key={i}>{renderInline(item, `${idx}-${i}`)}</li>
            ))}
          </ul>
        );
      }
      return (
        <p key={idx} style={{ whiteSpace: 'pre-line', marginBottom: '0.75rem' }}>
          {renderInline(block.lines.join('\n'), `${idx}`)}
        </p>
      );
    });
  };

  return (
    <div className="admissions-page">
      <section>
        {/* <SecondaryBanner
          imageUrl={BannerImg}
          title="One choice today. A lifetime of difference."
          desc="Your Journey to Silicon Valley Starts Here!"
          themeColor="sh-contentimgsplit--orange-theme"
        /> */}
        <div className='admissions-banner'>
          <div className='banner-content'>
            <h1>Your Journey to Silicon Valley Starts Here!</h1>
            <p>One choice today. A lifetime of difference.</p>
          </div>
        </div>

      </section>
      <main className="main-content">
        <section className="application-dates">
          <div className="date-cards">
            <div className="date-card deadline-card">
              <img src={Calendar} alt="calendar" className="calender-img" style={{ width: '50px', marginBottom: '10px' }} />
              <h3>Application Opens</h3>
              <p>{APPLICATION_OPEN_DATE_DISPLAY}</p>
            </div>
            <div className="date-card deadline-card">
              <img src={Calendar} alt="calendar" className="calender-img" style={{ width: '50px', marginBottom: '10px' }} />
              <h3>Application Deadline</h3>
              <p>{APPLICATION_CLOSE_DATE_DISPLAY}</p>
            </div>
            <div className="date-card deadline-card">
              <img src={Calendar} alt="calendar" className="calender-img" style={{ width: '50px', marginBottom: '10px' }} />
              <h3>Results</h3>
              <p>Starting from first week of July, 2026</p>
            </div>
          </div>

          <div className="mb-5 mt-5 apply-link" style={{ gap: '20px', flexWrap: 'wrap' }}>
            <a href={LeafletEn} download="2026_Sitare_Admissions_Leaflet.pdf" className="global-orangeBtn">
              Download Leaflet (English)
            </a>
            <a href={LeafletHi} download="2026_Sitare_Admissions_Leaflet.pdf" className="global-orangeBtn">
              Download Leaflet (Hindi)
            </a>
          </div>

          {today < applicationOpenDate && <p style={{
            display: "flex",
            justifyContent: "center"
          }}><i>Come back here when applications open to access the application portal. Or go to <a href="https://admissions.sitare.org" target="_blank" rel="noreferrer">admissions.sitare.org.</a></i></p>}

          {today > applicationCloseDate && <p style={{
            display: "flex",
            justifyContent: "center"
          }}>Applications for 2026 are now closed.</p>}


          {today > applicationOpenDate && today <= applicationCloseDate && <div className="mb-5 mt-5 apply-link">
            <Link
              to={
                "https://admissions.sitare.org/"
              }
              target="_blank"
              className="global-orangeBtn"
            >
              Apply Now
            </Link>
          </div>}
        </section>

        <section className="faq-section">
          <div className="faq-header">
            <h3 className="faq--header-text">FREQUENTLY ASKED QUESTIONS</h3>
          </div>
          {FAQS.map((group, groupIndex) => (
            <div className="faq-category" key={groupIndex}>
              <h4 className="faq-category-title">{group.category}</h4>
              <div className="accordion" id={`accordionFlushExample-${groupIndex}`}>
                {group.items.map(({ question, answer, link }, itemIndex) => {
                  const key = `${groupIndex}-${itemIndex}`;
                  const isActive = activeKey === key;
                  return (
                    <div className="accordion-item cu-enquries--item" key={key}>
                      <h2 className="accordion-header cu-enquries--header" id={`flush-heading${key}`}>
                        <button
                          className={`accordion-button cu-enquries--button ${isActive ? '' : 'collapsed'}`}
                          type="button"
                          onClick={() => toggleItem(key)}
                          aria-expanded={isActive}
                          aria-controls={`flush-collapse${key}`}
                        >
                          <span className="faq-question">{question}</span>
                        </button>
                      </h2>
                      <div
                        id={`flush-collapse${key}`}
                        className={`accordion-collapse collapse ${isActive ? 'show' : ''}`}
                        aria-labelledby={`flush-heading${key}`}
                      >
                        <div className="accordion-body cu-enquries--body">
                          {renderAnswer(answer.replace('{{APPLICATION_CLOSE_DATE}}', APPLICATION_CLOSE_DATE_DISPLAY))}
                          {link && (
                            <p>
                              <a href={link} target="_blank" rel="noopener noreferrer">
                                {link}
                              </a>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

        </section>
      </main>
    </div>
  );
};

export default Admissions;
